import type { ImageCropperLabels } from '@repletoryreach/sdk-ui/image-cropper';
import type { Translate } from '../i18n/I18nProvider';

/**
 * Every string the picture editor renders, from this console's catalogue.
 * The package defaults to English so that no copy needing translation lives
 * outside the catalogue; this is where the two meet. Placeholders here are the
 * package's single braces ({edge}, {min}), filled by the editor itself.
 */
export function imageCropperLabels(t: Translate): ImageCropperLabels {
  return {
    title: t('imageCropper.title'),
    instructions: t('imageCropper.instructions'),
    stage: t('imageCropper.stage'),
    zoom: t('imageCropper.zoom'),
    zoomIn: t('imageCropper.zoomIn'),
    zoomOut: t('imageCropper.zoomOut'),
    zoomValue: t('imageCropper.zoomValue'),
    preview: t('imageCropper.preview'),
    previewAlt: t('imageCropper.previewAlt'),
    output: t('imageCropper.output'),
    fillNote: t('imageCropper.fillNote'),
    reset: t('imageCropper.reset'),
    cancel: t('imageCropper.cancel'),
    confirm: t('imageCropper.confirm'),
    loading: t('imageCropper.loading'),
    decodeError: t('imageCropper.decodeError'),
    exportError: t('imageCropper.exportError'),
    lowResolution: t('imageCropper.lowResolution')
  };
}
